var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:("position: absolute; top: 0; right: 0; bottom: 0; left: 0; overflow: hidden")},[_c('iframe',{ref:"missingIFrame",style:("width: 100%; height: 100%; border: 0;"),attrs:{"src":_vm.endpoints.microFrontend}})])}
var staticRenderFns = []

export { render, staticRenderFns }